"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9552],{

/***/ 75913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZV": function() { return /* binding */ fetchJSON; },
/* harmony export */   "ty": function() { return /* binding */ postJSON; }
/* harmony export */ });
/* unused harmony exports postRoute, deleteJSON */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79225);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60818);



var fetchJSON = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(path) {
        var ref, _throwOnError, throwOnError, _tmp, response, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : _tmp, _throwOnError = ref.throwOnError, throwOnError = _throwOnError === void 0 ? true : _throwOnError;
                    _tmp1 = {};
                    return [
                        4,
                        __webpack_require__.g.fetch(path, (_tmp1.headers = new Headers({
                            Accept: "application/json"
                        }), _tmp1.credentials = "same-origin", _tmp1))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        unwrapJSONResponse(response, throwOnError)
                    ];
            }
        });
    });
    return function fetchJSON(path) {
        return _ref.apply(this, arguments);
    };
}();
var postRoute = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(path) {
        var ref, _throwOnError, throwOnError, _tmp, response, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : _tmp, _throwOnError = ref.throwOnError, throwOnError = _throwOnError === void 0 ? true : _throwOnError;
                    _tmp1 = {};
                    return [
                        4,
                        __webpack_require__.g.fetch(path, (_tmp1.method = "POST", _tmp1.credentials = "same-origin", _tmp1))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        unwrapJSONResponse(response, throwOnError)
                    ];
            }
        });
    });
    return function postRoute(path) {
        return _ref.apply(this, arguments);
    };
}();
var postJSON = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(path, body) {
        var ref, _throwOnError, throwOnError, _headers, headers, _credentials, credentials, _tmp, _tmp1, response, _tmp2;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    _tmp1 = {};
                    ref = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : _tmp, _throwOnError = ref.throwOnError, throwOnError = _throwOnError === void 0 ? true : _throwOnError, _headers = ref.headers, headers = _headers === void 0 ? _tmp1 : _headers, _credentials = ref.credentials, credentials = _credentials === void 0 ? "same-origin" : _credentials;
                    _tmp2 = {};
                    return [
                        4,
                        __webpack_require__.g.fetch(path, (_tmp2.method = "POST", _tmp2.body = JSON.stringify(body), _tmp2.headers = new Headers((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        }, headers)), _tmp2.credentials = credentials, _tmp2))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        unwrapJSONResponse(response, throwOnError)
                    ];
            }
        });
    });
    return function postJSON(path, body) {
        return _ref.apply(this, arguments);
    };
}();
var deleteJSON = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(path) {
        var ref, _throwOnError, throwOnError, _tmp, response, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : _tmp, _throwOnError = ref.throwOnError, throwOnError = _throwOnError === void 0 ? true : _throwOnError;
                    _tmp1 = {};
                    return [
                        4,
                        __webpack_require__.g.fetch(path, (_tmp1.method = "DELETE", _tmp1.headers = new Headers({
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        }), _tmp1.credentials = "same-origin", _tmp1))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        unwrapJSONResponse(response, throwOnError)
                    ];
            }
        });
    });
    return function deleteJSON(path) {
        return _ref.apply(this, arguments);
    };
}();
function unwrapJSONResponse(response, throwOnError) {
    return _unwrapJSONResponse.apply(this, arguments);
}
function _unwrapJSONResponse() {
    _unwrapJSONResponse = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(response, throwOnError) {
        var errorMessage, originalMessage, errData, ref, ref1, ref2, ref3, res, message, data, err, _$err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (response.ok || !throwOnError) {
                        return [
                            2,
                            response.json()
                        ];
                    }
                    errorMessage = "HTTP Status Error: ".concat(response.status);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    res = _state.sent();
                    message = ((ref = res.error) === null || ref === void 0 ? void 0 : ref.message) || ((ref1 = res.meta) === null || ref1 === void 0 ? void 0 : ref1.error);
                    if (message) {
                        errorMessage = "HTTP Status Error: ".concat(response.status, " - ").concat(message);
                        originalMessage = message;
                    }
                    data = ((ref2 = res.error) === null || ref2 === void 0 ? void 0 : ref2.data) || ((ref3 = res.meta) === null || ref3 === void 0 ? void 0 : ref3.errorData);
                    if (data) {
                        errData = data;
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error(err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    _$err = new Error(errorMessage);
                    // Mark this error as having the response data to work with
                    // As opposed to a network error
                    _$err.responseSucceeded = true;
                    _$err.statusCode = response.status;
                    _$err.originalMessage = originalMessage;
                    _$err.data = errData;
                    throw _$err;
            }
        });
    });
    return _unwrapJSONResponse.apply(this, arguments);
}


/***/ }),

/***/ 83337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Enum": function() { return /* reexport */ Enum; },
  "anyValueDefined": function() { return /* reexport */ anyValueDefined; },
  "checkParam": function() { return /* reexport */ checkParam; },
  "filterNilValues": function() { return /* binding */ filterNilValues; },
  "filterObj": function() { return /* binding */ filterObj; },
  "listOfKeys": function() { return /* binding */ listOfKeys; },
  "listOfValues": function() { return /* binding */ listOfValues; },
  "mapObj": function() { return /* binding */ mapObj; },
  "placeKeyInData": function() { return /* binding */ placeKeyInData; }
});

// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(29224);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(81142);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62204);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59573);
// EXTERNAL MODULE: ../../../../../node_modules/ramda/es/index.js + 232 modules
var es = __webpack_require__(91689);
;// CONCATENATED MODULE: ../../../../libraries/src/language-helpers/objects/check-object-keys.ts
/* eslint array-callback-return: "off" */ 
function checkParam(obj) {
    Object.entries(obj).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        if (typeof value === "object" && value !== null) {
            checkParam(value);
        }
        if (value === undefined || value === null) {
            throw new Error("".concat(key, " is a mandatory parameter"));
        }
    });
}

;// CONCATENATED MODULE: ../../../../libraries/src/language-helpers/objects/enum.ts
function Enum(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        acc[key] = key;
        return acc;
    }, {});
}

;// CONCATENATED MODULE: ../../../../libraries/src/language-helpers/objects/any-value-defined.ts
function anyValueDefined(obj) {
    return Object.values(obj).some(function(val) {
        return val !== undefined;
    });
}

;// CONCATENATED MODULE: ../../../../libraries/src/language-helpers/objects/index.ts





function filterObj(fn, obj) {
    var res = {};
    Object.entries(obj).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
        if (fn(k, v)) {
            res[k] = v;
        }
    });
    return res;
}
function mapObj(fn, obj) {
    var res = {};
    Object.entries(obj).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
        var ref = (0,_sliced_to_array/* default */.Z)(fn(k, v), 2), newK = ref[0], newV = ref[1];
        res[newK] = newV;
    });
    return res;
}
function filterNilValues(obj) {
    var result = filterObj(function(k, v) {
        return !(0,es/* isNil */.kKJ)(v);
    }, obj);
    return result;
}
function placeKeyInData(keyName, obj) {
    if (!keyName || typeof keyName !== "string") {
        throw new Error("keyName must be provided to placeKeyInData(keyName, obj)");
    }
    return mapObj(function(key, value) {
        return [
            key,
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), (0,_define_property/* default */.Z)({}, keyName, key)), 
        ];
    }, obj);
}
function listOfKeys(obj) {
    return Object.entries(obj).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
        return v;
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), k = _param[0];
        return k;
    });
}
function listOfValues(obj) {
    return Object.entries(obj).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
        return v;
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
        return v;
    });
}





/***/ }),

/***/ 11523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ isDomainValid; },
/* harmony export */   "J2": function() { return /* binding */ appendResourceType; },
/* harmony export */   "Ri": function() { return /* binding */ createURL; },
/* harmony export */   "ru": function() { return /* binding */ appendQuery; }
/* harmony export */ });
/* unused harmony export buildPath */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59573);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25439);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54885);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91689);
/* harmony import */ var _language_helpers_objects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83337);





function createURL(param) {
    var host = param.host, path = param.path, queryParams = param.queryParams, hash = param.hash;
    var url = new URL("".concat(host).concat(path));
    Object.entries(queryParams).forEach(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        if (value === undefined || value === null) {
            return;
        }
        if (typeof value === "object") {
            url.searchParams.set(key, JSON.stringify(value));
        } else {
            url.searchParams.set(key, value);
        }
    });
    if (hash) {
        url.hash = hash;
    }
    return url.toString();
}
function appendQuery(path, query) {
    if ((0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .isNil */ .kKJ)(query)) {
        return path;
    }
    var filteredQuery = (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .pickBy */ .D95)(function(val) {
        return !(0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .isNil */ .kKJ)(val) && !(0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .isEmpty */ .xbD)(val);
    }, query);
    if ((0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .isEmpty */ .xbD)(filteredQuery)) {
        return path;
    }
    var queryStr = querystring__WEBPACK_IMPORTED_MODULE_1__.encode(filteredQuery);
    return "".concat(path, "?").concat(queryStr);
}
function appendResourceType(type, url) {
    (0,_language_helpers_objects__WEBPACK_IMPORTED_MODULE_3__.checkParam)({
        type: type
    });
    (0,_language_helpers_objects__WEBPACK_IMPORTED_MODULE_3__.checkParam)({
        url: url
    });
    var parsed = (0,url__WEBPACK_IMPORTED_MODULE_0__.parse)(url);
    var path = buildPath(type, parsed);
    if (!parsed.hostname) {
        return path;
    }
    return "".concat(parsed.protocol, "//").concat(parsed.host).concat(path);
}
function buildPath(type, param) {
    var pathname = param.pathname, search = param.search;
    if (search) {
        return "".concat(pathname, ".").concat(type).concat(search);
    }
    return "".concat(pathname, ".").concat(type);
}
var DOMAIN_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9]+[-.]?)*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;
var isDomainValid = function(domain) {
    return !!(domain && domain.match(DOMAIN_REGEX));
};


/***/ }),

/***/ 24741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ routeTo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62204);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60628);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38137);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60586);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68964);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11141);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90171);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24686);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: inherit;\n  :hover {\n    color: inherit;\n  }\n\n  text-decoration: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Link = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(_param) {
    var href = _param.href, path = _param.path, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "href",
        "path",
        "children"
    ]);
    if (typeof href === "string" && !href.startsWith("/")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            href: href
        }, props), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        as: path,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            children: children
        }))
    });
})(_templateObject(), function(param) {
    var underline = param.underline;
    return underline ? "underline" : "none";
});
var routeTo = function routeTo(href, path) {
    var scroll = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return next_router__WEBPACK_IMPORTED_MODULE_3___default().push(href, path).then(function() {
        if (scroll) {
            scrollToTop();
        }
    });
};
function scrollToTop() {
    if (__webpack_require__.g.window) {
        __webpack_require__.g.window.scrollTo(0, 0);
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 5721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SegmentWrapper; },
/* harmony export */   "u": function() { return /* binding */ SegmentSnippet; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22130);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60586);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90171);
/* harmony import */ var react_inline_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9049);
/* harmony import */ var react_inline_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_inline_script__WEBPACK_IMPORTED_MODULE_2__);




var SegmentSnippet = function SegmentSnippet(param) {
    var apiKey = param.apiKey;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_inline_script__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: '\n      !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";\n        analytics.load(\''.concat(apiKey, "');\n      }}();\n  ")
    });
};
var SegmentTestWrapper = {
    identify: function identify() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _analytics;
        (_analytics = window.analytics).identify.apply(_analytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        if (window.testAnalytics) {
            var _testAnalytics;
            (_testAnalytics = window.testAnalytics).identify.apply(_testAnalytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        }
    },
    track: function track() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _analytics;
        (_analytics = window.analytics).track.apply(_analytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        if (window.testAnalytics) {
            var _testAnalytics;
            (_testAnalytics = window.testAnalytics).track.apply(_testAnalytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        }
    },
    page: function page() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _analytics;
        (_analytics = window.analytics).page.apply(_analytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        if (window.testAnalytics) {
            var _testAnalytics;
            (_testAnalytics = window.testAnalytics).page.apply(_testAnalytics, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
        }
    }
};
var SegmentWrapper = {
    identify: function identify(userId, traits, options, callback) {
        try {
            SegmentTestWrapper.identify(userId, traits, options, callback);
        } catch (_err) {
        /* ignored */ }
    },
    track: function track(event, properties, options, callback) {
        try {
            SegmentTestWrapper.track(event, properties, options, callback);
        } catch (_err) {
        /* ignored */ }
    },
    page: function page(category, name, properties, options, callback) {
        try {
            SegmentTestWrapper.page(category, name, properties, options, callback);
        } catch (_err) {
        /* ignored */ }
    }
};



/***/ }),

/***/ 13393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79225);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60818);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75913);
/* harmony import */ var _purple_dot_libraries_src_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11523);
/* harmony import */ var _components_common_linking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24741);
/* eslint-disable no-underscore-dangle */ 




var expressPage = function expressPage(pageComponent) {
    if (componentHasProps(pageComponent)) {
        // eslint-disable-next-line no-param-reassign
        pageComponent.getInitialProps = getInitialProps;
    }
    return pageComponent;
};
function componentHasProps(pageComponent) {
    return pageComponent.length > 0;
}
function getInitialProps(_) {
    return _getInitialProps.apply(this, arguments);
}
function _getInitialProps() {
    _getInitialProps = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var req, query, asPath, url, data, __redirect, pathname, q, path, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    req = param.req, query = param.query, asPath = param.asPath;
                    if (!!isOnServer(req)) return [
                        3,
                        2
                    ];
                    url = (0,_purple_dot_libraries_src_url__WEBPACK_IMPORTED_MODULE_1__/* .appendResourceType */ .J2)("json", asPath);
                    return [
                        4,
                        (0,_purple_dot_browser_sdk_src_libraries_fetch__WEBPACK_IMPORTED_MODULE_0__/* .fetchJSON */ .ZV)(url)
                    ];
                case 1:
                    data = _state.sent();
                    _tmp = {};
                    if (data._redirect) {
                        __redirect = data._redirect, pathname = __redirect.pathname, q = __redirect.query, path = __redirect.path;
                        (0,_components_common_linking__WEBPACK_IMPORTED_MODULE_2__/* .routeTo */ .E)((_tmp.pathname = pathname, _tmp.query = q, _tmp), path);
                    }
                    return [
                        2,
                        data
                    ];
                case 2:
                    return [
                        2,
                        query
                    ];
            }
        });
    });
    return _getInitialProps.apply(this, arguments);
}
function isOnServer(req) {
    return !!req;
}
/* harmony default export */ __webpack_exports__["Z"] = (expressPage);


/***/ })

}]);